import { InjectionToken, Injectable, Inject, ɵɵdefineInjectable, ɵɵinject, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import Debug from 'debug';
import { Router, ActivatedRoute } from '@angular/router';
import { createAction, props, createSelector, createReducer, on, select, Store, StoreModule } from '@ngrx/store';
import { createEntityAdapter } from '@ngrx/entity';
import { NamedString, InjectedTextProvider, InjectedTextFeautureModule } from '@modeso/modeso-lib-core-fe';
import { createEffect, ofType, Actions, EffectsModule } from '@ngrx/effects';
import { CommonModule } from '@angular/common';
import { mergeMap, retry, tap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/products.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ProductsConfig() { }
if (false) {
    /** @type {?} */
    ProductsConfig.prototype.serviceId;
}
/** @type {?} */
const ProductsConfigService = new InjectionToken('Config');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/products.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug = Debug('modeso:lidl-lib-products-fe:ProductsService');
/** @type {?} */
const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
    })
};
/**
 * @record
 */
function ProductsResponse() { }
if (false) {
    /** @type {?} */
    ProductsResponse.prototype.products;
}
class ProductsService {
    /**
     * @param {?} http
     * @param {?} config
     */
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.server = '';
        this.microserviceName = 'products';
        this.productsRoute = '/';
        this.singleProductRoute = ':id';
        this.categoryParam = ':cat';
        this.categoryRoute = 'category';
        this.server = config.apiGateway;
        debug('ProductServiceId: ' + config.serviceId);
    }
    /**
     * @return {?}
     */
    getAllProducts() {
        debug('get all products called');
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.productsRoute}`;
        return this.http.get(url);
    }
    /**
     * @param {?} category
     * @return {?}
     */
    getProductsByCategory(category) {
        /** @type {?} */
        const productCategory = this.categoryParam.replace(':cat', category);
        debug('get products by category called');
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.productsRoute}${this.categoryRoute}${this.productsRoute}${productCategory}`;
        return this.http.get(url);
    }
}
ProductsService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
ProductsService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [ProductsConfigService,] }] }
];
/** @nocollapse */ ProductsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ProductsService_Factory() { return new ProductsService(ɵɵinject(HttpClient), ɵɵinject(ProductsConfigService)); }, token: ProductsService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ProductsService.prototype.server;
    /**
     * @type {?}
     * @private
     */
    ProductsService.prototype.microserviceName;
    /**
     * @type {?}
     * @private
     */
    ProductsService.prototype.productsRoute;
    /**
     * @type {?}
     * @private
     */
    ProductsService.prototype.singleProductRoute;
    /**
     * @type {?}
     * @private
     */
    ProductsService.prototype.categoryParam;
    /**
     * @type {?}
     * @private
     */
    ProductsService.prototype.categoryRoute;
    /**
     * @type {?}
     * @private
     */
    ProductsService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    ProductsService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/actions/product-details.actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * We can change the product details state using the actions.
 * This is action of product details.
 * @type {?}
 */
const getProductById = createAction('[Product] getProductById', props());
/**
 * This is action of product details when it return successfully.
 * @type {?}
 */
const onProductDetailsLoadedSuccessfully = createAction('[Product Detail]  productById loaded successfully', props());
/**
 * This is action of product details when it failed.
 * @type {?}
 */
const onProductDetailsLoadingFailed = createAction('[Product Detail]  productById loading failed', props());
/**
 * Dispatch to pass payload, you can create parametrizied Action in this way.
 * @record
 * @template T
 */
function ActionWithPayload() { }
if (false) {
    /** @type {?} */
    ActionWithPayload.prototype.payload;
}
/**
 * @record
 */
function ActionWithProductId() { }
if (false) {
    /** @type {?} */
    ActionWithProductId.prototype.productId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reducers/product-details.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Using feature keys to register each reducer.
 * The feature key will define the name of the property in the state.
 * @type {?}
 */
const productDetailsFeatureKey = 'modesoProductDetailsMicroservice';
// State Declarations - START
/**
 * These methods are provided by the adapter object returned when using createEntityAdapter.
 * The methods are used inside your reducer function to manage the entity collection based on your provided actions.
 * @type {?}
 */
const adapter = createEntityAdapter({
    selectId: selectproductId,
    sortComparer: sortById
});
/**
 *
 * @param {?} a product detail model selected.
 * @return {?}
 */
function selectproductId(a) {
    return a.productId;
}
/**
 *
 * @param {?} a product detail model selected.
 * @param {?} b product detail model selected.
 * @return {?}
 */
function sortById(a, b) {
    return a.productId.localeCompare(b.productId);
}
/**
 * @record
 */
function FeatureState() { }
/**
 * @record
 */
function AppState() { }
if (false) {
    /** @type {?} */
    AppState.prototype.modesoProductDetailsMicroservice;
}
// State Declarations - END
// Selectors Declarations - START
/**
 *
 * \@param state state of AppState
 * @type {?}
 */
const selectFeature = (/**
 * @param {?} state
 * @return {?}
 */
(state) => state.modesoProductDetailsMicroservice);
const ɵ0 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state;
/** @type {?} */
const selectFeatureProducts = createSelector(selectFeature, (ɵ0));
/**
 * Get the selectors.
 * The getSelectors method returned by the created entity adapter provides functions for selecting information from the entity.
 * The getSelectors method takes a selector function as its only argument to select the piece of state for a defined entity.
 */
const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
/** @type {?} */
const selectProductEntities = createSelector(selectFeatureProducts, selectEntities);
/** @type {?} */
const selectProductAllEntities = createSelector(selectFeatureProducts, selectAll);
const ɵ1 = /**
 * @param {?} entities
 * @param {?} props
 * @return {?}
 */
(entities, props) => {
    return entities[props.id];
};
/** @type {?} */
const selectEntitiesByID = createSelector(selectProductEntities, (ɵ1));
const ɵ2 = /**
 * @param {?} entities
 * @param {?} props
 * @return {?}
 */
(entities, props) => {
    return entities.filter((/**
     * @param {?} product
     * @return {?}
     */
    product => product.price === props.filter));
};
/** @type {?} */
const selectEntitiesByFilter = createSelector(selectProductAllEntities, (ɵ2));
// Selectors Declarations - END
// Reducer Declarations - START
/** @type {?} */
const initialState = adapter.getInitialState();
const ɵ3 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ4 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.addOne(action.payload, Object.assign({}, state));
}, ɵ5 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state));
/**
 * The reducer function's responsibility is to handle the state transitions in an immutable way.
 * Create a reducer function that handles the actions for managing the state of the scoreboard using the createReducer function.
 * @type {?}
 */
const productDetailsReducer = createReducer(initialState, on(getProductById, (ɵ3)), on(onProductDetailsLoadedSuccessfully, (ɵ4)), on(onProductDetailsLoadingFailed, (ɵ5)));
/**
 *
 * @param {?} state state of product details.
 * @param {?} action action of product details.
 * @return {?}
 */
function reducer(state, action) {
    return productDetailsReducer(state, action);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/actions/products.actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const getAllProducts = createAction('[Product List] getAllProducts');
/** @type {?} */
const onAllProductsLoadedSuccessfully = createAction('[Product List] all products loaded successfully', props());
/**
 * create an Action of get product by id
 * check https://ngrx.io/guide/store/actions
 * \@param1 handle of the action with ngrx convention
 * \@param2 props method is used to define any additional metadata
 *         needed for the handling of the action
 * @type {?}
 */
const getProductById$1 = createAction('[Product List] getProductById', props());
/** @type {?} */
const onAllProductsLoadingFailed = createAction('[Product List] all products loading failed', props());
/** @type {?} */
const getProductsByCategory = createAction('[Product List] getProductsByCategory', props());
/** @type {?} */
const onGetProductByCategorySuccessfully = createAction('[Product List] get product by category succefully', props());
/** @type {?} */
const onGetProductByCategoryFailed = createAction('[Product List] get product by category failed', props());
/**
 * @record
 * @template T
 */
function ActionWithPayload$1() { }
if (false) {
    /** @type {?} */
    ActionWithPayload$1.prototype.payload;
}
/**
 * @record
 */
function ActionWithProductCategory() { }
if (false) {
    /** @type {?} */
    ActionWithProductCategory.prototype.productCategory;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reducers/products.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const productsFeatureKey = 'modesoProductsMicroservice';
/**
 * @record
 */
function FeatureState$1() { }
if (false) {
    /** @type {?} */
    FeatureState$1.prototype.products;
    /** @type {?} */
    FeatureState$1.prototype.productsByCategory;
}
/**
 * @record
 */
function AppState$1() { }
if (false) {
    /** @type {?} */
    AppState$1.prototype.modesoProductsMicroservice;
}
// State Declarations - END
// Selectors Declarations - START
/** @type {?} */
const selectFeature$1 = (/**
 * @param {?} state
 * @return {?}
 */
(state) => state.modesoProductsMicroservice);
const ɵ0$1 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.products;
/** @type {?} */
const selectFeatureProducts$1 = createSelector(selectFeature$1, (ɵ0$1));
const ɵ1$1 = /**
 * @param {?} entities
 * @param {?} props
 * @return {?}
 */
(entities, props) => {
    return entities.products.find((/**
     * @param {?} product
     * @return {?}
     */
    product => product.productId === props.id));
};
/**
 * selector to get product by id from products array of the store
 * @type {?}
 */
const selectProductById = createSelector(selectFeature$1, (ɵ1$1));
const ɵ2$1 = /**
 * @param {?} entities
 * @return {?}
 */
(entities) => {
    return entities.productsByCategory;
};
/** @type {?} */
const selectProductsByCategory = createSelector(selectFeature$1, (ɵ2$1));
// Selectors Declarations - END
// Reducer Declarations - START
/** @type {?} */
const initialState$1 = {
    products: new Array(),
    productsByCategory: new Array()
};
const ɵ3$1 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ4$1 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { products: action.payload })), ɵ5$1 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ6 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ7 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { productsByCategory: action.payload })), ɵ8 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state));
/** @type {?} */
const productsReducer = createReducer(initialState$1, on(getAllProducts, (ɵ3$1)), on(onAllProductsLoadedSuccessfully, (ɵ4$1)), on(onAllProductsLoadingFailed, (ɵ5$1)), on(getProductsByCategory, (ɵ6)), on(onGetProductByCategorySuccessfully, (ɵ7)), on(onGetProductByCategoryFailed, (ɵ8)));
/**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
function reducer$1(state, action) {
    return productsReducer(state, action);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/provider/productStore.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const strings = [
    { 'modeso_cart_add-to-cart_total_exceeded_error': 'modeso_cart_add-to-cart_total_exceeded_error' }
];
class ProductStoreProvider {
    /**
     * @param {?} store
     * @param {?} injectedTextProvider
     */
    constructor(store, injectedTextProvider) {
        this.store = store;
        this.injectedTextProvider = injectedTextProvider;
        /** @type {?} */
        const defaultStrings = new Array();
        strings.forEach((/**
         * @param {?} element
         * @return {?}
         */
        (element) => {
            /** @type {?} */
            const x = new NamedString(Object.keys(element)[0], element[Object.keys(element)[0]]);
            defaultStrings.push(x);
        }));
        this.setInjectedText(defaultStrings);
    }
    /**
     * @param {?} productId
     * @return {?}
     */
    getProduct$(productId) {
        if (productId) {
            /** @type {?} */
            const ret = this.store.pipe(select(selectEntitiesByID, { id: productId }));
            //this.store.dispatch(getProductById({productId}));
            return ret;
        }
        else {
            return undefined;
        }
    }
    /**
     * @private
     * @param {?} injectedText
     * @return {?}
     */
    setInjectedText(injectedText) {
        this.injectedTextProvider.setInjectedText(injectedText);
    }
    /**
     * @param {?} productCategory
     * @return {?}
     */
    getProductsByCategory$(productCategory) {
        this.store.dispatch(getProductsByCategory({ productCategory }));
        return this.store.pipe(select(selectProductsByCategory));
    }
}
ProductStoreProvider.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ProductStoreProvider.ctorParameters = () => [
    { type: Store },
    { type: InjectedTextProvider }
];
/** @nocollapse */ ProductStoreProvider.ngInjectableDef = ɵɵdefineInjectable({ factory: function ProductStoreProvider_Factory() { return new ProductStoreProvider(ɵɵinject(Store), ɵɵinject(InjectedTextProvider)); }, token: ProductStoreProvider, providedIn: "root" });
if (false) {
    /** @type {?} */
    ProductStoreProvider.prototype.store;
    /**
     * @type {?}
     * @private
     */
    ProductStoreProvider.prototype.injectedTextProvider;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/product-notification.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductNotificationModel {
}
if (false) {
    /** @type {?} */
    ProductNotificationModel.prototype.isError;
    /** @type {?} */
    ProductNotificationModel.prototype.message;
    /** @type {?} */
    ProductNotificationModel.prototype.productId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/product-list/product-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$1 = Debug('lidl:shop:product-list page');
class ProductListComponent {
    /**
     * @param {?} router
     * @param {?} route
     * @param {?} productStoreProvider
     */
    constructor(router, route, productStoreProvider) {
        this.router = router;
        this.route = route;
        this.productStoreProvider = productStoreProvider;
        this.showNotification = false;
        this.redirectToCartEvent = new EventEmitter();
    }
    /**
     * @param {?} productNotification
     * @return {?}
     */
    set productNotificationSetter(productNotification) {
        if (productNotification) {
            this.hasError = productNotification.isError;
            this.notificationMessage = productNotification.message;
            this.productId = productNotification.productId;
            this.showNotification = true;
        }
        else {
            this.showNotification = false;
            this.notificationMessage = '';
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.route.params.subscribe((/**
         * @param {?} routeParams
         * @return {?}
         */
        routeParams => {
            this.loadProducts(routeParams.cat);
            this.hasError = false;
            this.showNotification = false;
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.gtagProductList(this.productsByCategory);
            }), 1000);
        }));
    }
    /**
     * @param {?} productsCategory
     * @return {?}
     */
    loadProducts(productsCategory) {
        this.productStoreProvider.getProductsByCategory$(productsCategory).subscribe((/**
         * @param {?} products
         * @return {?}
         */
        (products) => {
            if (products) {
                debug$1('products are set...');
                debug$1(products);
                this.productsByCategory = products;
            }
            else {
                debug$1('products is not set...');
                debug$1(products);
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => {
            debug$1('products by category error ...');
            debug$1(error);
        }));
    }
    /**
     * will navigate on details click to the selected product
     * @param {?} productId productId of the card get it from child card
     * @return {?}
     */
    onDetailsClick(productId) {
        this.navigateToProductPage(productId, this.getLanguageFromLocalStorage());
    }
    /**
     * check if there is a currentLanguage in localstorage will return it else will return 'de-ch' as a default language
     * @private
     * @return {?}
     */
    getLanguageFromLocalStorage() {
        return localStorage.getItem('currentLanguage') ? localStorage.getItem('currentLanguage') : `de-ch`;
    }
    /**
     * navigate to product page
     * @private
     * @param {?} productId product id
     * @param {?} language default language
     * @return {?}
     */
    navigateToProductPage(productId, language) {
        this.router.navigateByUrl(`/${language}/giftcard/${productId}`);
    }
    /**
     * @return {?}
     */
    fireNavigateToCartEvent() {
        this.redirectToCartEvent.emit();
    }
    /**
     * @param {?} products
     * @return {?}
     */
    gtagProductList(products) {
        /** @type {?} */
        const finalProducts = [];
        window.dataLayer = window.dataLayer || [];
        for (var i = 0; i < products.length; i++) {
            /** @type {?} */
            let productImpression = {};
            productImpression.name = products[i].name;
            productImpression.id = products[i].productId;
            productImpression.category = products[i].category;
            productImpression.position = i + 1;
            finalProducts.push(productImpression);
        }
        window.dataLayer.push({ 'ecommerce': null });
        window.dataLayer.push({
            'event': 'EECproductImpression',
            'ecommerce': {
                'impressions': finalProducts,
            }
        });
    }
}
ProductListComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-product-list',
                template: "<div class=\"products-container row\">\n  <ng-container *ngFor=\"let product of productsByCategory\">\n    <lib-product-card class=\"col-lg-4\" (detailsClickEvent)=\"onDetailsClick($event)\" [product]=\"product\"\n      [showDetailsButtonCaption]=\"showDetailsButtonCaption\">\n      <ng-container *ngTemplateOutlet=\"templateRef; context: {$implicit: product}\"></ng-container>\n      <div class=\"notification-message-wrapper\">\n        <div [ngClass]=\"{'display': (product.productId === productId), 'error-message': (hasError && showNotification), 'success-message': (!hasError && showNotification)}\" class=\"col-lg-12 notification-message\">\n          <span> {{ notificationMessage | injectedText | async }}</span>\n          <a (click)=\"fireNavigateToCartEvent()\"> {{'modeso_cart_added-to-cart_go-to-cart' | injectedText | async}} </a>\n        </div>\n      </div>\n    </lib-product-card>\n\n  </ng-container>\n</div>",
                styles: [".cart-wrapper{background-color:#f2f3f4;display:flex;min-height:180px}.cart-wrapper__cart{display:flex;margin-left:auto;display:flex}.cart-wrapper__cart .cart-add{border:2px solid #6a7cdf;background-color:#6a7cdf;color:#fff;font-size:16px;padding:15px 6px;height:-webkit-min-content;height:-moz-min-content;height:min-content}.cart-wrapper__cart .cart-count{background-color:#fff;color:#6a7cdf;border:2px solid #6a7cdf;font-size:16px;padding:15px 10px;height:-webkit-min-content;height:-moz-min-content;height:min-content}.notification-message{height:0;display:table;visibility:hidden;width:100%}.notification-message.error-message{background-color:red}.notification-message.success-message{background-color:#00e471}.notification-message.display{visibility:visible;transition:height 1s ease-out;height:52px}.notification-message span{line-height:18px}.notification-message a,.notification-message span{color:#fff;vertical-align:middle;display:table-cell}.notification-message a{cursor:pointer;text-align:right;white-space:nowrap;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.notification-message-wrapper{height:50px}"]
            }] }
];
/** @nocollapse */
ProductListComponent.ctorParameters = () => [
    { type: Router },
    { type: ActivatedRoute },
    { type: ProductStoreProvider }
];
ProductListComponent.propDecorators = {
    templateRef: [{ type: Input }],
    showDetailsButtonCaption: [{ type: Input }],
    productId: [{ type: Input }],
    notificationMessage: [{ type: Input }],
    hasError: [{ type: Input }],
    showNotification: [{ type: Input }],
    redirectToCartEvent: [{ type: Output }],
    productNotificationSetter: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProductListComponent.prototype.templateRef;
    /** @type {?} */
    ProductListComponent.prototype.showDetailsButtonCaption;
    /** @type {?} */
    ProductListComponent.prototype.productId;
    /** @type {?} */
    ProductListComponent.prototype.notificationMessage;
    /** @type {?} */
    ProductListComponent.prototype.hasError;
    /** @type {?} */
    ProductListComponent.prototype.showNotification;
    /** @type {?} */
    ProductListComponent.prototype.redirectToCartEvent;
    /** @type {?} */
    ProductListComponent.prototype.productsByCategory;
    /**
     * @type {?}
     * @private
     */
    ProductListComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    ProductListComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    ProductListComponent.prototype.productStoreProvider;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/product-detail/product-detail.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$2 = Debug('modeso:lidl-lib-products-fe:ProductDetailComponent');
class ProductDetailComponent {
    /**
     *
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.productId === undefined) {
            debug$2('productId is not defined');
            return;
        }
        else {
            this.product$ = this.store.pipe(select(selectEntitiesByID, { id: this.productId }));
            this.store.dispatch(getProductById({ productId: this.productId }));
            this.gtagDetailpage();
        }
    }
    /**
     * @return {?}
     */
    gtagDetailpage() {
        this.product$.subscribe((/**
         * @param {?} product
         * @return {?}
         */
        (product) => {
            if (!product)
                return;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                'event': 'EECproductDetailView',
                'ecommerce': {
                    'detail': {
                        'actionField': {},
                        'products': [{
                                'name': product.name,
                                'id': product.productId,
                                'category': product.category,
                            }]
                    }
                }
            });
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        sessionStorage.removeItem('isProductAddedToCart');
    }
}
ProductDetailComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-product-detail',
                template: "<div class=\"product-details-container\">\n  <div class=\"row\">\n    <div class=\"col\">\n      <h1>{{ product$ ?  (product$ | async)?.name: 'TITLE UNDEFINED'}}</h1>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-6\">\n      <img src=\"{{ product$ ?  (product$ | async)?.image: 'https://via.placeholder.com/544x364' }}\">\n    </div>\n    <div class=\"col-lg-6\">\n      <div [innerHtml]=\"(product$ ?  (product$ | async)?.longDescription: 'LONG DESC UNDEFINED')\"></div>\n      <div class=\"price-box\">\n        <modeso-product-price [price]=\" product$ ?  (product$ | async)?.price : 'PRICE UNDEFINED'\">\n        </modeso-product-price>\n        <div class=\"add-to-cart\">\n          <ng-content select=\"[add-to-cart]\"></ng-content>\n        </div>\n        <!-- <ng-container *ngTemplateOutlet=\"companyLogoTemplate\"></ng-container> -->\n      </div>\n      <ng-content select=\"[notification-message]\"></ng-content>\n    </div>\n  </div>\n</div>\n",
                styles: [".product-details-container img{width:100%;max-height:100%;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;margin-bottom:30px}.product-details-container .price-box{background-color:#f2f3f4;display:flex;padding:1rem;width:100%;margin-top:20px}.product-details-container .price-box .add-to-cart{padding:0 18px;width:100%}"]
            }] }
];
/** @nocollapse */
ProductDetailComponent.ctorParameters = () => [
    { type: Store }
];
ProductDetailComponent.propDecorators = {
    productId: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProductDetailComponent.prototype.productId;
    /** @type {?} */
    ProductDetailComponent.prototype.product$;
    /**
     * @type {?}
     * @private
     */
    ProductDetailComponent.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/product-price/product-price.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductPriceComponent {
    constructor() { }
}
ProductPriceComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-product-price',
                template: "<div class=\"lidl-lib-products-fe-price\">\n    <!-- <label>CHF</label>\n    <span>{{price}}</span> -->\n</div>\n",
                styles: [".lidl-lib-products-fe-price label{padding-right:.3rem;font-weight:300}.lidl-lib-products-fe-price span{font-size:2em}"]
            }] }
];
/** @nocollapse */
ProductPriceComponent.ctorParameters = () => [];
ProductPriceComponent.propDecorators = {
    price: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProductPriceComponent.prototype.price;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/product-details.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Product Details Model that return
 */
class ProductDetailsModel {
    /**
     *
     * @param {?} productId the product id.
     * @param {?} name the product name.
     * @param {?} image the product image.
     * @param {?} shortDescription short description about the product.
     * @param {?} longDescription long description about the product.
     * @param {?} price price of the product.
     * @param {?} packagePrice the price of packaging the product.
     * @param {?} variablePrice the variable price of the product.
     * @param {?} category product category (physical / digital).
     * @param {?} ean product ean number.
     * @param {?} pdfTemplatePath
     */
    constructor(productId, name, image, shortDescription, longDescription, price, packagePrice, variablePrice, category, ean, pdfTemplatePath) {
        this.productId = productId;
        this.name = name;
        this.image = image;
        this.shortDescription = shortDescription;
        this.longDescription = longDescription;
        this.price = price;
        this.packagePrice = packagePrice;
        this.variablePrice = variablePrice;
        this.category = category;
        this.ean = ean;
        this.pdfTemplatePath = pdfTemplatePath;
    }
}
if (false) {
    /** @type {?} */
    ProductDetailsModel.prototype.productId;
    /** @type {?} */
    ProductDetailsModel.prototype.name;
    /** @type {?} */
    ProductDetailsModel.prototype.image;
    /** @type {?} */
    ProductDetailsModel.prototype.shortDescription;
    /** @type {?} */
    ProductDetailsModel.prototype.longDescription;
    /** @type {?} */
    ProductDetailsModel.prototype.price;
    /** @type {?} */
    ProductDetailsModel.prototype.packagePrice;
    /** @type {?} */
    ProductDetailsModel.prototype.variablePrice;
    /** @type {?} */
    ProductDetailsModel.prototype.category;
    /** @type {?} */
    ProductDetailsModel.prototype.ean;
    /** @type {?} */
    ProductDetailsModel.prototype.pdfTemplatePath;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/product-details.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ProductDetailResponse() { }
if (false) {
    /** @type {?} */
    ProductDetailResponse.prototype.product;
}
class ProductDetailsService {
    /**
     *
     * @param {?} http
     * @param {?} config
     */
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.server = '';
        this.microserviceName = 'products';
        this.productsRoute = '/';
        this.singleProductRoute = ':id';
        this.server = config.apiGateway;
    }
    /**
     * Service to return product details data from backend using http.
     * @param {?} id
     * @return {?}
     */
    getProductById(id) {
        /** @type {?} */
        const proudctId = this.singleProductRoute.replace(':id', id);
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.productsRoute}${proudctId}`;
        return this.http.get(url);
    }
}
ProductDetailsService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
ProductDetailsService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [ProductsConfigService,] }] }
];
/** @nocollapse */ ProductDetailsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ProductDetailsService_Factory() { return new ProductDetailsService(ɵɵinject(HttpClient), ɵɵinject(ProductsConfigService)); }, token: ProductDetailsService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ProductDetailsService.prototype.server;
    /**
     * @type {?}
     * @private
     */
    ProductDetailsService.prototype.microserviceName;
    /**
     * @type {?}
     * @private
     */
    ProductDetailsService.prototype.productsRoute;
    /**
     * @type {?}
     * @private
     */
    ProductDetailsService.prototype.singleProductRoute;
    /**
     * @type {?}
     * @private
     */
    ProductDetailsService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    ProductDetailsService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/effects/products.effects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$3 = Debug('modeso:lidl-lib-products-fe:ProductsEffects');
class ProductsEffects {
    /**
     * @param {?} actions$
     * @param {?} service
     */
    constructor(actions$, service) {
        this.actions$ = actions$;
        this.service = service;
        this.loadAllProducts$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(getAllProducts.type), mergeMap((/**
         * @return {?}
         */
        () => {
            return this.service.getAllProducts()
                .pipe(retry(1), tap((/**
             * @param {?} response
             * @return {?}
             */
            response => debug$3(response))), map((/**
             * @param {?} productsResponse
             * @return {?}
             */
            productsResponse => (onAllProductsLoadedSuccessfully({ payload: productsResponse.products })))), 
            // tslint:disable-next-line:object-literal-shorthand
            catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onAllProductsLoadingFailed({ payload: error })))));
        })))));
        this.loadAllProductsByCategory$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(getProductsByCategory.type), mergeMap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => {
            debug$3(`product details should be loaded for ${action.productCategory}`);
            return this.service.getProductsByCategory(action.productCategory)
                .pipe(map((/**
             * @param {?} productsByCategoryResponse
             * @return {?}
             */
            (productsByCategoryResponse) => (onGetProductByCategorySuccessfully({ payload: productsByCategoryResponse.products })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onGetProductByCategoryFailed({ payload: error })))));
        })))));
        this.errorOnLoadByCategory$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onGetProductByCategoryFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadAllProductsErrors(action.payload))))), { dispatch: false });
        this.errorOnLoadAllProducts$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onAllProductsLoadingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadAllProductsErrors(action.payload))))), { dispatch: false });
    }
    /**
     * @param {?} error
     * @return {?}
     */
    handleOnLoadAllProductsErrors(error) {
        debug$3(error);
        return error;
    }
}
ProductsEffects.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ProductsEffects.ctorParameters = () => [
    { type: Actions },
    { type: ProductsService }
];
if (false) {
    /** @type {?} */
    ProductsEffects.prototype.loadAllProducts$;
    /** @type {?} */
    ProductsEffects.prototype.loadAllProductsByCategory$;
    /** @type {?} */
    ProductsEffects.prototype.errorOnLoadByCategory$;
    /** @type {?} */
    ProductsEffects.prototype.errorOnLoadAllProducts$;
    /**
     * @type {?}
     * @private
     */
    ProductsEffects.prototype.actions$;
    /**
     * @type {?}
     * @private
     */
    ProductsEffects.prototype.service;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/effects/product-details.effects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$4 = Debug('modeso:lidl-lib-products-fe:ProductDetailsEffects');
class ProductDetailsEffects {
    /**
     * @param {?} actions$
     * @param {?} service
     */
    constructor(actions$, service) {
        this.actions$ = actions$;
        this.service = service;
        /**
         * An injectable Actions service that provides an observable stream of all actions dispatched after the latest state has been reduced.
         * Metadata is attached to the observable streams using the createEffect function. The metadata is used to register the streams that
         * are subscribed to the store.
         * Any action returned from the effect stream is then dispatched back to the Store.
         * Actions are filtered using a pipeable ofType operator. The ofType operator takes one or more action types as
         * arguments to filter on which actions to act upon.
         * Effects are subscribed to the Store observable.
         * Services are injected into effects to interact with external APIs and handle streams.
         */
        this.loadProductById$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(getProductById.type), mergeMap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => {
            debug$4(`product details should be loaded for ${action.productId}`);
            return this.service.getProductById(action.productId)
                .pipe(retry(1), tap((/**
             * @param {?} response
             * @return {?}
             */
            (response) => this.log(response))), map((/**
             * @param {?} response
             * @return {?}
             */
            response => (onProductDetailsLoadedSuccessfully({ payload: response.product })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onProductDetailsLoadingFailed({ payload: error })))));
        })))));
        /**
         * ErrorOnLoadProductById$ effect handling errors when fetching product details.
         */
        this.errorOnLoadProductById$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onProductDetailsLoadingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadAllProductErrors(action.payload))))), { dispatch: false });
    }
    /**
     * @param {?} error
     * @return {?}
     */
    handleOnLoadAllProductErrors(error) {
        debug$4(error);
        return error;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    log(data) {
        debug$4('data: ', data);
    }
}
ProductDetailsEffects.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ProductDetailsEffects.ctorParameters = () => [
    { type: Actions },
    { type: ProductDetailsService }
];
if (false) {
    /**
     * An injectable Actions service that provides an observable stream of all actions dispatched after the latest state has been reduced.
     * Metadata is attached to the observable streams using the createEffect function. The metadata is used to register the streams that
     * are subscribed to the store.
     * Any action returned from the effect stream is then dispatched back to the Store.
     * Actions are filtered using a pipeable ofType operator. The ofType operator takes one or more action types as
     * arguments to filter on which actions to act upon.
     * Effects are subscribed to the Store observable.
     * Services are injected into effects to interact with external APIs and handle streams.
     * @type {?}
     */
    ProductDetailsEffects.prototype.loadProductById$;
    /**
     * ErrorOnLoadProductById$ effect handling errors when fetching product details.
     * @type {?}
     */
    ProductDetailsEffects.prototype.errorOnLoadProductById$;
    /**
     * @type {?}
     * @private
     */
    ProductDetailsEffects.prototype.actions$;
    /**
     * @type {?}
     * @private
     */
    ProductDetailsEffects.prototype.service;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/product.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductModel {
    /**
     * @param {?} productId
     * @param {?} ean
     * @param {?} name
     * @param {?} price
     * @param {?} category
     * @param {?} pdfTemplatePath
     * @param {?=} description
     * @param {?=} image
     * @param {?=} shortDescription
     * @param {?=} modesotype
     * @param {?=} packagePrice
     * @param {?=} variablePrice
     */
    constructor(productId, ean, name, price, category, pdfTemplatePath, description, image, shortDescription, modesotype, packagePrice, variablePrice) {
        this.productId = productId;
        this.ean = ean;
        this.name = name;
        this.price = price;
        this.category = category;
        this.pdfTemplatePath = pdfTemplatePath;
        this.description = description;
        this.image = image;
        this.shortDescription = shortDescription;
        this.modesotype = modesotype;
        this.packagePrice = packagePrice;
        this.variablePrice = variablePrice;
    }
}
if (false) {
    /** @type {?} */
    ProductModel.prototype.productId;
    /** @type {?} */
    ProductModel.prototype.ean;
    /** @type {?} */
    ProductModel.prototype.name;
    /** @type {?} */
    ProductModel.prototype.price;
    /** @type {?} */
    ProductModel.prototype.category;
    /** @type {?} */
    ProductModel.prototype.pdfTemplatePath;
    /** @type {?} */
    ProductModel.prototype.description;
    /** @type {?} */
    ProductModel.prototype.image;
    /** @type {?} */
    ProductModel.prototype.shortDescription;
    /** @type {?} */
    ProductModel.prototype.modesotype;
    /** @type {?} */
    ProductModel.prototype.packagePrice;
    /** @type {?} */
    ProductModel.prototype.variablePrice;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/product-card/product-card.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductCardComponent {
    constructor() {
        this.detailsClickEvent = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * emit the card productId to the parent "product-list" to navigate with it
     * @param {?} productId product Id of the card
     * @return {?}
     */
    onDetailsClick(productId) {
        this.detailsClickEvent.emit(productId);
    }
    /**
     * destroy the eventEmitter on component destroy
     * @return {?}
     */
    ngOnDestroy() {
        this.detailsClickEvent.unsubscribe();
    }
}
ProductCardComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-product-card',
                template: "<div class=\"card-body-wrapper\" id={{product.productId}}>\n    <div class=\"card-body-wrapper__img\">\n      <img src={{product.image}} class=\"card-img-top\" alt={{product.name}}>\n    </div>\n    <div class=\"card-details\">\n      <h3>{{product.name}} {{product.price}}</h3>\n      <p>{{product.shortDescription}}</p>\n    </div>\n    <div class=\"product-card-action-wrapper\">\n      <div class=\"product-card-action-wrapper__inputs\">\n        <ng-content></ng-content>\n      </div>\n      <div>\n        <a (click)=\"onDetailsClick(product.productId)\" class=\"details-btn\" name={{product.productId}}>{{showDetailsButtonCaption}}</a>\n      </div>\n  </div>\n</div>",
                styles: ["h3{font-weight:700;font-stretch:normal;font-style:normal}.card-img-top{height:100%;-o-object-fit:contain;object-fit:contain}.card-body-wrapper{display:flex;flex-direction:column;height:100%;max-width:25em;margin:auto auto 2em}.card-body-wrapper__img{height:250px;overflow:hidden}.product-card-action-wrapper{display:flex;flex-wrap:wrap;justify-content:flex-end}.product-card-action-wrapper__inputs{width:100%}.product-card-action-wrapper a.details-btn{display:flex;align-items:center;padding:.2em 0;border-radius:0;-webkit-appearance:none;margin-right:auto;font-size:1rem;border-bottom:1px solid #000;color:#000;margin-top:10px}.product-card-action-wrapper a.details-btn:hover{cursor:pointer;text-decoration:none;color:#026ca6}.card-details{margin-bottom:auto}"]
            }] }
];
/** @nocollapse */
ProductCardComponent.ctorParameters = () => [];
ProductCardComponent.propDecorators = {
    product: [{ type: Input }],
    showDetailsButtonCaption: [{ type: Input }],
    detailsClickEvent: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ProductCardComponent.prototype.product;
    /** @type {?} */
    ProductCardComponent.prototype.showDetailsButtonCaption;
    /** @type {?} */
    ProductCardComponent.prototype.detailsClickEvent;
    /** @type {?} */
    ProductCardComponent.prototype.product$;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/products.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductsModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: ProductsModule,
            providers: [
                ProductsService,
                {
                    provide: ProductsConfigService,
                    useValue: config
                },
                ProductDetailsService
            ]
        };
    }
}
ProductsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [ProductListComponent, ProductDetailComponent, ProductPriceComponent, ProductCardComponent],
                providers: [ProductsService, ProductDetailsService],
                imports: [
                    CommonModule,
                    InjectedTextFeautureModule,
                    StoreModule.forFeature(productsFeatureKey, reducer$1),
                    StoreModule.forFeature(productDetailsFeatureKey, reducer),
                    EffectsModule.forFeature([ProductsEffects]),
                    EffectsModule.forFeature([ProductDetailsEffects])
                ],
                exports: [ProductListComponent, ProductDetailComponent, ProductPriceComponent, ProductCardComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/product-variable-price.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductVariablePriceModel {
}
if (false) {
    /** @type {?} */
    ProductVariablePriceModel.prototype.from;
    /** @type {?} */
    ProductVariablePriceModel.prototype.to;
    /** @type {?} */
    ProductVariablePriceModel.prototype.defaultPrice;
}

/**
 * @fileoverview added by tsickle
 * Generated from: modeso-giftcardshop-lib-products-fe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ProductDetailComponent, ProductDetailsModel, ProductListComponent, ProductPriceComponent, ProductStoreProvider, ProductsConfigService, ProductsModule, ProductsService, productDetailsFeatureKey as ɵa, adapter as ɵb, selectproductId as ɵc, sortById as ɵd, initialState as ɵf, reducer as ɵg, ProductVariablePriceModel as ɵh, ProductCardComponent as ɵi, ProductDetailsService as ɵj, productsFeatureKey as ɵk, initialState$1 as ɵl, reducer$1 as ɵm, getAllProducts as ɵn, onAllProductsLoadedSuccessfully as ɵo, onAllProductsLoadingFailed as ɵp, getProductsByCategory as ɵq, onGetProductByCategorySuccessfully as ɵr, onGetProductByCategoryFailed as ɵs, getProductById as ɵt, onProductDetailsLoadedSuccessfully as ɵu, onProductDetailsLoadingFailed as ɵv, ProductsEffects as ɵw, ProductDetailsEffects as ɵx };
